<ion-content [fullscreen]="true">
  <ion-row>
    <ion-col>
      <p>
        Des actions sont requises de votre part.
      </p>
      <p>
        Merci de bien vouloir prépayer ou clôturer vos prestations.
      </p>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <div class="button-container">
        <ion-img src="../../../../assets/img/ajout_logement_illustration.png"></ion-img>
        <ion-icon class="checkmarkcirclee" (click)="dismiss()" name="checkmark-circle"></ion-icon>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
